import { useTranslation } from 'react-i18next'
import defaultCover from '@/themes/alemira/img/instructors.png'
import styles from './EmptySearchResults.module.scss'

export const EmptySearchResults = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.emptySearchResults}>
      <img src={defaultCover} alt={t('catalogList.emptySearchResults')} />
      <div className={styles.title}>{t('catalogList.emptySearchResults')}</div>
      <div className={styles.subTitle}>{t('catalogList.retryText')}</div>
    </div>
  )
}
